import React, { useEffect, useState } from 'react'
import { Button, Card, Row, Col, Form, Modal } from 'react-bootstrap'
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { toast } from 'react-toastify';
import { errorResponse } from '../helper/error';
import Loader from './Loader/Loader';

const Footer = (props) => {
    const serverURL = getServerURL()

    const [editModalShow, setEditModalShow] = useState(false);
    const [editData, setEditData] = useState({})
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(true)
    const [subLoader, setSubLoader] = useState(false)
    const [data, setData] = useState({});

    useEffect(() => {
        getFooterData();
    }, []);

    const getFooterData = (event) => {
        api.getWithToken(`${serverURL}page/footer/`)
            .then(async (res) => {
                setLoading(false)
                if (res?.data?.success === true) {
                    setData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
                errorResponse(e)
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditData((prevValues) => ({
            ...prevValues,
            [name]: value.trimStart(),
        }));
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        setSubLoader(true)
        if (form.checkValidity()) {
            api.putWithToken(`${serverURL}page/footer/`, editData)
                .then(async (res) => {
                    setEditModalShow(false)
                    setLoading(false);
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getFooterData()
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    setSubLoader(false)
                    // errorResponse(e);
                });
            setValidated(false);
        } else {
            setSubLoader(false)
            setValidated(true);
            event.stopPropagation();
        }
    };

    return (
        <div>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title + " Details" || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                            </header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setEditData(data); setEditModalShow(true) }}>
                                {"Edit"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="d-flex p-4 gap-3">
                        <div className="d-flex justify-content-between w-100 pl-4">
                            <table>
                                <tbody>
                                    {Boolean(loading) ?
                                        <tr>
                                            <Loader loading={loading} />
                                        </tr>
                                        :
                                        Boolean(Object.keys(data)?.length) &&
                                        <>
                                            <tr>
                                                <td>Whatsapp Number :</td>
                                                <td className="ps-3">
                                                    {data?.whats_app_no || "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Facebook Link :</td>
                                                <td className="ps-3">
                                                    {data?.facebook_link || "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Instagram Link :</td>
                                                <td className="ps-3">
                                                    {data?.instagram_link || "-"}
                                                </td>
                                            </tr>
                                        </>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {/* edit Modal */}
            <Modal
                show={editModalShow}
                onHide={() => setEditModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h4">Edit {props?.title} Details</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        Whatsapp Number
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter whatsapp" value={editData?.whats_app_no || ""} name='whats_app_no' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalLastName">
                                    <Form.Label column sm={3}>
                                        Facebook Link
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter facebook link" value={editData?.facebook_link || ""} name='facebook_link' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3}>
                                        Instagram Link
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter instagram link" value={editData?.instagram_link || ""} name='instagram_link' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <div className='d-flex justify-content-end pt-2'>
                                    <Button type='submit' className='m-0'>Update</Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Footer